import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ShoppingBag, User, Search } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';

const categories = [
  { name: 'Belts', path: '/shop/belts' },
  { name: 'Wallets', path: '/shop/wallets' },
  { name: 'Purses', path: '/shop/purses' },
  { name: 'Dog Collars', path: '/shop/dog_collars' },
  { name: 'Cologne', path: '/shop/cologne' },
];

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const { itemCount, setIsOpen } = useCart();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-cream-50/95 backdrop-blur-sm border-b border-cream-200">
      {/* ...removed duplicate running banner... */}
      <nav className="px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="logo-text text-xl md:text-2xl text-leather-900" data-testid="logo">
            BELT & TINGZ
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-10">
            {categories.map((cat) => (
              <Link
                key={cat.path}
                to={cat.path}
                className="nav-link text-sm tracking-wide uppercase text-leather-600 hover:text-leather-900"
                data-testid={`nav-${cat.name.toLowerCase().replace(' ', '-')}`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Right Icons */}
          <div className="flex items-center gap-6">
            <button className="hidden md:block text-leather-600 hover:text-leather-900" data-testid="search-btn">
              <Search className="w-5 h-5" />
            </button>

            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="text-leather-600 hover:text-leather-900" data-testid="user-menu-btn">
                    <User className="w-5 h-5" />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-48 bg-cream-50">
                  <DropdownMenuItem onClick={() => navigate('/account')} className="cursor-pointer">
                    My Account
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => navigate('/orders')} className="cursor-pointer">
                    Orders
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={logout} className="cursor-pointer text-red-600">
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <Link to="/login" className="text-leather-600 hover:text-leather-900" data-testid="login-link">
                <User className="w-5 h-5" />
              </Link>
            )}

            <button
              onClick={() => setIsOpen(true)}
              className="relative text-leather-600 hover:text-leather-900"
              data-testid="cart-btn"
            >
              <ShoppingBag className="w-5 h-5" />
              {itemCount > 0 && (
                <span className="cart-badge" data-testid="cart-count">{itemCount}</span>
              )}
            </button>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-leather-600"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-6 border-t border-cream-200" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.path}
                  to={cat.path}
                  className="text-sm tracking-wide uppercase text-leather-600 hover:text-leather-900 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="text-sm tracking-wide uppercase text-leather-600 hover:text-leather-900 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/contact"
                className="text-sm tracking-wide uppercase text-leather-600 hover:text-leather-900 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
